import { render, staticRenderFns } from "./paymentSuccess.vue?vue&type=template&id=4dd8fa87&scoped=true"
import script from "./paymentSuccess.vue?vue&type=script&lang=js"
export * from "./paymentSuccess.vue?vue&type=script&lang=js"
import style0 from "./paymentSuccess.vue?vue&type=style&index=0&id=4dd8fa87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8fa87",
  null
  
)

export default component.exports